import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'; 

import { AccountService } from '../../_services/account.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html'
})
export class EditUserComponent implements OnInit {
  contactUUID: string = "";
  contactTypeList: any = [];
  userInfo: any = {};
  update_message: string = "";

  editUserForm: FormGroup = new FormGroup({
    first_name: new FormControl(""),
    last_name: new FormControl(""),
    email: new FormControl(""),
    active: new FormControl(""),
    is_sales: new FormControl(""),
    description : new FormControl(""),
    // role: new FormControl("")
  })

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private account: AccountService,
    private tokenStorage: TokenStorageService,
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getUserProfile();
      }
  });
  }

  ngOnInit(): void {
    this.getUserProfile();
  }


  getUserProfile(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    const userid = this.activatedRoute.snapshot.params['userid'];
   
    this.account.getAccountProfile$(userid, this.contactUUID).subscribe((profile: {}) => {
      this.userInfo = profile;
      console.log(' this.userInfo ',  this.userInfo );

      this.editUserForm.setValue({
        first_name: this.userInfo.first_name,
        last_name: this.userInfo.last_name,
        email: this.userInfo.email,
        description: this.userInfo.description,
        active: this.userInfo.active,
        is_sales : this.userInfo.is_sales,
      });
    })
/*
    this.account.getCapabilities$(this.contactUUID).subscribe((data: any) => {
      console.log("List of capabilities : ", data)
    })
    */
    
  }
  
  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(values: any): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    const userid = this.activatedRoute.snapshot.params['userid'];

    let accountInfo = {
      "first_name": values.first_name,
      "last_name": values.last_name,
      "email": values.email,
      "active": values.active,
      "is_sales": values.is_sales,
      "login": this.userInfo.login,
      "description": values.description,
      "updated": this.userInfo.updated,
      "hash": "",
    }

    this.account.updateAccount$(userid , contactUUID, accountInfo).subscribe({
      next: (data:any) => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the user ", data);
        this.userInfo.updated = data.updated;
        this.goToTop();
      },
      error: (err: any) => {
        console.log("Something went wrong updating the user: ", err)
      }
    })
  }

  logout(): void {
   
    console.log('logging out');
    this.router.navigate(['/connexion'])
    .then(() => {
      this.tokenStorage.signOut();
      location.reload();
    });

  }

}
